import { targetAudiences } from "../../SchoolsView/Activities"

export const prepareOptions = (filter: number[]) => {
    return targetAudiences.filter(targetAudience => filter.includes(targetAudience.id)).map(targetAudience => {
        return { id: targetAudience.name, name: targetAudience.name }
    })
}
